<h1 mat-dialog-title>Please choose carefully!</h1>
<div mat-dialog-content>
    <p>{{data.question}}</p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="confirm()" cdkFocusInitial>Confirm</button>
    <button mat-raised-button type="button" (click)="onNoClick()">No</button>
</div>